// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"9007":"59e272efbeaa433e","9775":"8124716b0ac09cf2"}[chunkId] + ".css";
};